import { AnalyticsWindow } from "./analytics-window"
import analyticsAction from "../analytics/analytics-action"

declare let window: AnalyticsWindow

export default function analyticsWistia() {
  // We track the following events related to Wistia videos:
  //   Video played: when the video progresses beyond 3%.
  //   Video watched: when the percentage watched reaches 30% we consider it "watched".
  // These events leverage Wistia's API: https://wistia.com/support/developers/player-api

  function handleWistiaVideoReady(video: any) {
    const videoProperties = {
      "Video provider": "wistia",
      "Video ID": video.hashedId(),
      "Video title": video.name(),
      "Video length": video.duration(),
    }

    let startedEventSent: boolean = false
    let watchedEvenSent: boolean = false

    video.bind(
      "percentwatchedchanged",
      function (percent: number, lastPercent: number) {
        // Determine if the video is a graphic only video
        // They are have autoplay, are muted, and have no playbar
        const { autoPlay, muted, playbar } = video.options
        if (autoPlay && muted && !playbar) return

        const currentStep =
          Math.round(((percent + lastPercent) / 2) * 100) / 100

        if (currentStep >= 0.03 && !startedEventSent) {
          startedEventSent = true
          analyticsAction("Video started", { ...videoProperties })
        }
        if (currentStep >= 0.3 && !watchedEvenSent) {
          watchedEvenSent = true
          analyticsAction("Video watched", { ...videoProperties })
        }
      },
    )
  }

  window._wq = window._wq || []

  // Attach behavior to any Wisita video on the page
  // See: https://wistia.com/support/developers/player-api#get-started
  window._wq.push({ id: "_all", onReady: handleWistiaVideoReady })
}
